import { forwardRef } from 'react';
import { BaseInput } from './__internal__/BaseInput';
import { jsx as _jsx } from "react/jsx-runtime";
export const Input = /*#__PURE__*/forwardRef(function Input({
  ...props
}, ref) {
  return /*#__PURE__*/_jsx(BaseInput, {
    ...props,
    ref: ref
  });
});
//# sourceMappingURL=Input.js.map